<template>
  <span
    class="tw-inline-flex tw-select-none tw-items-center tw-rounded-full tw-border tw-text-center tw-font-medium"
    :class="[
      colors[color],
      isInteractive && interactiveColors[color],
      sizes[size],
    ]"
    v-tooltip="tooltip"
  >
    <slot />

    <button
      v-if="removable"
      class="tw--m-1 tw-ml-2 tw-rounded-full tw-p-1 tw-transition-colors"
      :class="removeButtonColors[color]"
      @click="emit('remove')"
    >
      <CloseIcon class="tw-h-2.5 tw-w-2.5" />
    </button>
  </span>
</template>

<script setup lang="ts">
import CloseIcon from '@/assets/images/icons/close.svg'

const emit = defineEmits(['remove'])

type TagSize = 'small' | 'regular' | 'large'
type TagColor =
  | 'gray'
  | 'secondary'
  | 'outline-secondary'
  | 'green'
  | 'red'
  | 'yellow'
  | 'purple'

interface Props {
  size?: TagSize
  color?: TagColor
  tooltip?: string
  isInteractive?: boolean
  removable?: boolean
}

withDefaults(defineProps<Props>(), {
  size: 'regular',
  color: 'gray',
  tooltip: '',
  isInteractive: false,
  removable: false,
})

const colors = {
  gray: 'tw-text-neutral-500 tw-bg-neutral-50 tw-border-neutral-50',
  secondary: 'tw-text-primary-500 tw-bg-primary-50 tw-border-primary-50',
  'outline-secondary': 'tw-text-primary-500 tw-bg-white tw-border-primary-100',
  green: 'tw-text-success-700 tw-bg-success-50 tw-border-success-50',
  red: 'tw-text-error-700 tw-bg-error-50 tw-border-error-50',
  yellow: 'tw-text-warning-900 tw-bg-warning-50 tw-border-warning-50',
  purple: 'tw-text-secondary-700 tw-bg-secondary-50 tw-border-secondary-50',
}

const interactiveColors = {
  'outline-secondary':
    'tw-transition-colors hover:tw-bg-primary-50 hover:tw-text-primary-500 hover:tw-border-primary-50',
}

const sizes = {
  small: 'tw-text-[11px] tw-py-1 tw-px-2',
  regular: 'tw-text-xs tw-py-[6px] tw-px-3',
  large: 'tw-text-sm tw-py-2 tw-px-3',
}

const removeButtonColors = {
  purple: 'hover:tw-bg-secondary-100',
}
</script>
